
export class HighlightColorModel {
    alpha: number = 1;
    red!: number;
    green!: number;
    blue!: number;
}